import {HeaderMall9} from "../../../../../publicComponent/Header";
import Navigator from "../../../../../publicComponent/h5/Navigator";
import CouponCard from "../../../components/CouponCard";
import Button from "../../../../../publicComponent/Button";
import TabsMall9 from "../../../../../publicComponent/Tabs/TabMall9";
import {useEffect, useMemo} from "react";
import MyCouponContext, {MyCouponController, useMyCouponContext} from "../../../../../reducer/moduleReducer/my/myCoupon";
import Buffer from "../../../../../publicComponent/Buffer";
import {useTranslation} from "react-i18next";
import ScrollLoadWrap from "../../../../../publicComponent/ScrollLoadWrap";
import Pagination from "../../../../../publicComponent/Pagination";
import useNotice from "../../../../../hooks/useNotice";

function MyCouponWrap() {
  const { setActive, getCouponList } = MyCouponController();
  const { state } = useMyCouponContext();
  const { loading, query, couponList, statusTabs, tabActive, total } = state;
  const { t } = useTranslation();
  const notice = useNotice();
  
  const isNoMore = useMemo(() => {
    return couponList.length === total;
  }, [couponList, total]);
  
  useEffect(() => {
    getCouponList();
  }, []);
  
  return (
    <Navigator.container className="container-center">
      <h1 className="font-bold py-[30px] text-[24px] pb-[12px] mdmax:hidden">{t('我的优惠券')}</h1>
      <TabsMall9 tabs={statusTabs}
                 onChange={setActive}
                 active={tabActive}
                 tabsActiveColor="#ECBC40"
                 perview={4}/>
      {
        couponList && couponList.length > 0
          ? <>
            <ScrollLoadWrap className="relative px-[3%] mt-[15px] md:mt-[50px] grid grid-cols-3 mdmax:grid-cols-1 md:gap-4 mdmax:gap-4"
                            page={query.page}
                            getPage={getCouponList}
                            loading={loading}
                            isNoMore={isNoMore}
                            listHeightOffsetTop={60}>
              {
                couponList.map((item, i) => (
                  <CouponCard
                    key={i}
                    data={item}
                    className="mb-[12px] mdmax:mb-0"
                    button={
                      tabActive === '1'
                        ? <Button className="px-[10px] text-[13px] py-[3px] bg-[#ddd] cursor-not-allowed
                rounded-[99px] w-[80px]">{t('已使用')}</Button>
                        : <Button className="px-[10px] text-[13px] py-[3px] bg-[#eece7a]
              rounded-[99px] w-[80px]">{t('未使用')}</Button>}
                  />
                ))
              }
            </ScrollLoadWrap>
            <Pagination total={total}
                        current={query.page}
                        onChange={(page) => getCouponList({ page })}
                        className="mb-[100px]"/>
          </>
          : <Buffer.Empty content={t('暂无可用优惠')}/>
      }
    
    </Navigator.container>
  );
}

export default function MyCoupon() {
  return (
    <>
      <HeaderMall9/>
      <Navigator title="我的优惠券" goback noBorder/>
      <MyCouponContext>
        <MyCouponWrap/>
      </MyCouponContext>
    </>
  );
}
